import { IShowCheckOrgUsersParams } from "src/models";
import CheckOrgUsers from "src/components/CheckOrgUsers/CheckOrgUsers";

export default {
    checkOrgUsersComponent: null,

    dispose() {
        if (this.checkOrgUsersComponent) {
            this.checkOrgUsersComponent.dispose();
        }
        this.checkOrgUsersComponent = null;
    },

    show(params: IShowCheckOrgUsersParams, enforceNew?: boolean) {
        if (!this.checkOrgUsersComponent || enforceNew) {
            this.checkOrgUsersComponent = new CheckOrgUsers({
                source: '<x-check-org-users></x-check-org-users>'
            });
            this.checkOrgUsersComponent.attach(document.body);
        }
        this.checkOrgUsersComponent.show(params)
    }
};
